import './theme-init.js' // 防闪烁：Vue 挂载前应用主题偏好
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './styles/index.scss' // Token 体系 + 主题变量
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import permissionDirective from '@/directives/permission'

const buildId = process.env.VUE_APP_BUILD_ID || 'development'
window.__MPPLUS_BUILD_ID__ = buildId
document.documentElement.setAttribute('data-build-id', buildId)

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.directive('permission', permissionDirective)

// 过滤开发环境常见 ResizeObserver 噪音，避免遮罩误报
const installResizeObserverNoiseFilter = () => {
  const isResizeObserverNoise = (msg) => {
    const text = String(msg || '')
    return text.includes('ResizeObserver loop completed with undelivered notifications') ||
      text.includes('ResizeObserver loop limit exceeded')
  }

  window.addEventListener('error', (e) => {
    if (isResizeObserverNoise(e?.message)) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  }, true)

  window.addEventListener('unhandledrejection', (e) => {
    const reasonMsg = e?.reason?.message || e?.reason || ''
    if (isResizeObserverNoise(reasonMsg)) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  })
}

installResizeObserverNoiseFilter()

// 额外防护：包装 ResizeObserver 回调到 rAF，降低循环触发概率
if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'function') {
  const NativeResizeObserver = window.ResizeObserver
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer))
      })
    }
  }
}

app.mount('#app') 
